import React, { useState } from "react";
import "./contact.css";
import { FaEnvelope } from "react-icons/fa";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";

function Contact() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "Course Enquiry for Testing",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); // 🔥 Loading button

  const handleCaptchaChange = (value) => {
    setCaptchaVerified(!!value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Please enter your name";
    if (!formData.email.trim()) {
      newErrors.email = "Please enter a valid email address";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Please enter your mobile number";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Mobile number must be 10 digits";
    }

    if (!formData.message.trim()) newErrors.message = "Please enter a message";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (!captchaVerified) {
      setErrors({ captcha: "Please verify the CAPTCHA." });
      return;
    }

    setIsLoading(true); // 🔥 Start loading

    const formSend = new FormData();
    formSend.append("name", formData.name);
    formSend.append("email", formData.email);
    formSend.append("phone", formData.phone);
    formSend.append("subject", formData.subject);
    formSend.append("message", formData.message);

    try {
      const response = await fetch("https://fazoacademy.in/php/sendmail.php", {
        method: "POST",
        body: formSend,
      });

      const result = await response.text();
      console.log("Response:", result);

      if (result.includes("success") || result.includes("SUCCESS")) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "Course Enquiry for Testing",
          message: "",
        });

        navigate("/thankyou"); // 🔥 Redirect to thank you page
      } else {
        setResponseMessage("Email not sent. Try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setResponseMessage("Server error. Try again later.");
    } finally {
      setIsLoading(false); // 🔥 Stop loading
    }
  };

  return (
    <div className="container">
      <section className="contact-section">
        <div className="headlines-for-all">
          <h4>
            <span>Contact </span> Us
          </h4>
          <p>
            Get in touch with us for course details, career guidance, or any support.
          </p>
        </div>

        <div className="container d-flex justify-content-center">
          <div className="contact-wrapper">
            <div className="contact-form">
              <h2>Send us a message</h2>

              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Name :</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <p className="error">{errors.name}</p>}
                  </div>

                  <div className="form-group">
                    <label>Email :</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div>
                </div>

                <br></br>

                <div className="form-row">
                  <div className="form-group">
                    <label>Phone :</label>
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    {errors.phone && <p className="error">{errors.phone}</p>}
                  </div>
                    <div className="form-group">
                    <label>Subject :</label>
                    <input
                      type="text"
                      name="subject"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleChange}
                      disabled
                    />
                    {/* {errors.phone && <p className="error">{errors.phone}</p>} */}
                  </div>
                </div>
                     <br></br>

                <div className="form-group full">
                  <label>Message :</label>
                  <textarea
                    name="message"
                    placeholder="Write your message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                  />
                  {errors.message && <p className="error">{errors.message}</p>}
                </div>

     <br></br>
                <ReCAPTCHA
                  sitekey="6LcvphEsAAAAAEDI2D1bp3KMfYffeD_THqRX6-gG"
                  onChange={handleCaptchaChange}
                />

                {errors.captcha && <p className="error">{errors.captcha}</p>}

                <button type="submit" className="btn-submit" disabled={isLoading}>
                  {isLoading ? "SENDING..." : "SEND MESSAGE"}
                </button>

                {responseMessage && (
                  <p className="response-message">{responseMessage}</p>
                )}
              </form>
            </div>

            <div className="contact-info">
              <h3>Contact Information</h3>
<br></br>
              <p>
                <FaLocationDot color="red" /> &nbsp; &nbsp; No:21 Vinayaga Nagar,
                Okiyam Thoraipakkam, Chennai 600097.
              </p>
              <p>
                <FaPhone color="red" /> &nbsp; &nbsp; +91 6380866249
              </p>
              <p>
                <FaEnvelope color="red" />  &nbsp; &nbsp;info@fazoacademy.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
